import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b2f524c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "continue-to-manage-signatories"
}
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = {
  class: "modal-wrapper",
  ref: "modalWrapper"
}
const _hoisted_4 = { class: "modal-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Continue To Manage Authorised Signatories")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, " You are about to leave Part B and continue to the 'Manage Authorised Signatories' page. All information entered up to this point will be saved, and you will be redirected to that page. To proceed, please select Save and proceed. ")
], -1))
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = { class: "button-controls" }

export function render(_ctx, _cache) {
  return (_ctx.modalOpened)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_Transition, { name: "modal" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: "fal fa-times close-icon",
                    onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                  }),
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "btn btn-outline",
                        onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent"]))
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.continueClicked()), ["prevent"]))
                      }, "Save and proceed")
                    ])
                  ])
                ])
              ], 512)
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}